import * as React from 'react';
import { useSidebar } from '../hooks/useSidebar';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/joy/IconButton';
import MenuIcon from '@mui/icons-material/Menu';

export default function Header() {
    const [, setOpen] = useSidebar();

    return (
        <AppBar elevation={0} position="fixed" sx={(theme) => ({
            backgroundColor: 'var(--joy-palette-background-surface)',
            color: 'var(--joy-palette-text-primary)',
            borderBottom: `1px solid ${theme.palette.divider}`,
            backdropFilter: 'blur(14px)',
            zIndex: theme.zIndex.drawer + 1,
            display: { lg: 'none', md: 'flex', xs: 'flex' },
        })}>
            <Toolbar disableGutters sx={{ px: 1 }}>
                <IconButton onClick={() => setOpen(previous => !previous)}>
                    <MenuIcon sx={{ px: 1 }} />
                </IconButton>
            </Toolbar>
        </AppBar>
    );
}
